import {useSelector} from "react-redux";

export default function () {
    const customFields = useSelector(state => state?.customField?.customFields) || [];
    const listCustomFieldsLoading = useSelector(state => state?.customField?.listCustomFieldsLoading);

    return {customFields, listCustomFieldsLoading};
}